import { SET_MODAL_FACILITY } from 'store/types/facility';

export const setModalFacility = (modal) => {
  return {
    type: SET_MODAL_FACILITY,
    payload: modal,
  };
};
